/**
 * @generated SignedSource<<fa097fdf4ecc66ba2e480d2af8019801>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cancelationEndDate"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cancelationStartDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "currentTime"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patternId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "routeId"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showStopStatusMarkers"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startOfDay"
},
v8 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "patternId"
},
v9 = [
  (v8/*: any*/)
],
v10 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routeId"
  }
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "directionId",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gtfsId",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alertSeverityLevel",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveEndDate",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveStartDate",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceDay",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "realtimeDeparture",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "realtimeState",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledDeparture",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "platformCode",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v28 = [
  {
    "kind": "Variable",
    "name": "serviceDate",
    "variableName": "date"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "routeRoutes_PatternStopsContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Pattern",
        "kind": "LinkedField",
        "name": "pattern",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "currentTime",
                "variableName": "currentTime"
              },
              {
                "kind": "Variable",
                "name": "patternId",
                "variableName": "patternId"
              },
              {
                "kind": "Variable",
                "name": "showStopStatusMarkers",
                "variableName": "showStopStatusMarkers"
              },
              {
                "kind": "Variable",
                "name": "startOfDay",
                "variableName": "startOfDay"
              }
            ],
            "kind": "FragmentSpread",
            "name": "PatternStopsContainerFragment_pattern"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cancelationEndDate",
                "variableName": "cancelationEndDate"
              },
              {
                "kind": "Variable",
                "name": "cancelationStartDate",
                "variableName": "cancelationStartDate"
              },
              {
                "kind": "Variable",
                "name": "date",
                "variableName": "date"
              }
            ],
            "kind": "FragmentSpread",
            "name": "PatternStopsContainerFragment_route"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v4/*: any*/),
      (v5/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "routeRoutes_PatternStopsContainer_Query",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "Pattern",
        "kind": "LinkedField",
        "name": "pattern",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          (v12/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Route",
            "kind": "LinkedField",
            "name": "route",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Stop",
            "kind": "LinkedField",
            "name": "stops",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Alert",
                "kind": "LinkedField",
                "name": "alerts",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "alertEffect",
                    "storageKey": null
                  },
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "condition": "showStopStatusMarkers",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": "firstDeparture",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "numberOfDepartures",
                        "value": 1
                      },
                      {
                        "kind": "Literal",
                        "name": "omitCanceled",
                        "value": true
                      },
                      {
                        "kind": "Variable",
                        "name": "startTime",
                        "variableName": "startOfDay"
                      },
                      {
                        "kind": "Literal",
                        "name": "timeRange",
                        "value": 7776000
                      }
                    ],
                    "concreteType": "Stoptime",
                    "kind": "LinkedField",
                    "name": "stoptimesWithoutPatterns",
                    "plural": true,
                    "selections": [
                      (v22/*: any*/),
                      (v23/*: any*/)
                    ],
                    "storageKey": null
                  }
                ]
              },
              {
                "alias": null,
                "args": [
                  (v8/*: any*/),
                  {
                    "kind": "Variable",
                    "name": "startTime",
                    "variableName": "currentTime"
                  }
                ],
                "concreteType": "Stoptime",
                "kind": "LinkedField",
                "name": "stopTimesForPattern",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "realtime",
                    "storageKey": null
                  },
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "realtimeArrival",
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  (v22/*: any*/),
                  (v25/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pickupType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Stop",
                    "kind": "LinkedField",
                    "name": "stop",
                    "plural": false,
                    "selections": [
                      (v26/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v17/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lat",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "lon",
                "storageKey": null
              },
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "desc",
                "storageKey": null
              },
              (v11/*: any*/),
              (v26/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "zoneId",
                "storageKey": null
              },
              (v18/*: any*/)
            ],
            "storageKey": null
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v10/*: any*/),
        "concreteType": "Route",
        "kind": "LinkedField",
        "name": "route",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "longName",
            "storageKey": null
          },
          (v13/*: any*/),
          (v16/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Agency",
            "kind": "LinkedField",
            "name": "agency",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fareUrl",
                "storageKey": null
              },
              (v18/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "phone",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Pattern",
            "kind": "LinkedField",
            "name": "patterns",
            "plural": true,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headsign",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Stop",
                "kind": "LinkedField",
                "name": "stops",
                "plural": true,
                "selections": [
                  (v27/*: any*/),
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "activeDates",
                "args": null,
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "trips",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceId",
                    "storageKey": null
                  },
                  {
                    "alias": "day",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "activeDates",
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v28/*: any*/),
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": [
                  {
                    "alias": "stoptimes",
                    "args": (v28/*: any*/),
                    "concreteType": "Stoptime",
                    "kind": "LinkedField",
                    "name": "stoptimesForDate",
                    "plural": true,
                    "selections": [
                      (v25/*: any*/),
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              (v18/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "types",
                    "value": [
                      "ROUTE",
                      "STOPS_ON_PATTERN"
                    ]
                  }
                ],
                "concreteType": "Alert",
                "kind": "LinkedField",
                "name": "alerts",
                "plural": true,
                "selections": [
                  (v18/*: any*/),
                  (v19/*: any*/),
                  (v20/*: any*/),
                  (v21/*: any*/)
                ],
                "storageKey": "alerts(types:[\"ROUTE\",\"STOPS_ON_PATTERN\"])"
              },
              {
                "alias": "trips",
                "args": (v28/*: any*/),
                "concreteType": "Trip",
                "kind": "LinkedField",
                "name": "tripsForDate",
                "plural": true,
                "selections": [
                  {
                    "alias": "stoptimes",
                    "args": (v28/*: any*/),
                    "concreteType": "Stoptime",
                    "kind": "LinkedField",
                    "name": "stoptimesForDate",
                    "plural": true,
                    "selections": [
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "scheduledArrival",
                        "storageKey": null
                      },
                      (v25/*: any*/),
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v18/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "items": [
                      {
                        "fields": [
                          {
                            "kind": "Variable",
                            "name": "end",
                            "variableName": "cancelationEndDate"
                          },
                          {
                            "kind": "Variable",
                            "name": "start",
                            "variableName": "cancelationStartDate"
                          }
                        ],
                        "kind": "ObjectValue",
                        "name": "runningTimeRanges.0"
                      }
                    ],
                    "kind": "ListValue",
                    "name": "runningTimeRanges"
                  }
                ],
                "concreteType": "TripOnServiceDate",
                "kind": "LinkedField",
                "name": "canceledTrips",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "serviceDate",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Trip",
                    "kind": "LinkedField",
                    "name": "trip",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Pattern",
                        "kind": "LinkedField",
                        "name": "pattern",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v17/*: any*/),
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "52548f11df33bc223be64e08ba91f9ec",
    "id": null,
    "metadata": {},
    "name": "routeRoutes_PatternStopsContainer_Query",
    "operationKind": "query",
    "text": "query routeRoutes_PatternStopsContainer_Query(\n  $patternId: String!\n  $routeId: String!\n  $date: String!\n  $currentTime: Long!\n  $startOfDay: Long!\n  $showStopStatusMarkers: Boolean!\n  $cancelationStartDate: OffsetDateTime!\n  $cancelationEndDate: OffsetDateTime!\n) {\n  pattern(id: $patternId) {\n    ...PatternStopsContainerFragment_pattern_4qWgxv\n    id\n  }\n  route(id: $routeId) {\n    ...PatternStopsContainerFragment_route_2fFxM0\n    id\n  }\n}\n\nfragment PatternStopsContainerFragment_pattern_4qWgxv on Pattern {\n  code\n  ...RouteStopListContainerFragment_pattern_4qWgxv\n}\n\nfragment PatternStopsContainerFragment_route_2fFxM0 on Route {\n  gtfsId\n  color\n  shortName\n  longName\n  mode\n  type\n  ...RouteAgencyInfo_route\n  ...RoutePatternSelectContainerFragment_route_19b1FI\n  agency {\n    phone\n    name\n    id\n  }\n  patterns {\n    alerts(types: [ROUTE, STOPS_ON_PATTERN]) {\n      id\n      alertSeverityLevel\n      effectiveEndDate\n      effectiveStartDate\n    }\n    headsign\n    code\n    trips: tripsForDate(serviceDate: $date) {\n      stoptimes: stoptimesForDate(serviceDate: $date) {\n        realtimeState\n        scheduledArrival\n        scheduledDeparture\n        serviceDay\n      }\n      id\n    }\n    activeDates: trips {\n      serviceId\n      day: activeDates\n      id\n    }\n    canceledTrips(runningTimeRanges: [{start: $cancelationStartDate, end: $cancelationEndDate}]) {\n      serviceDate\n      trip {\n        pattern {\n          code\n          id\n        }\n        gtfsId\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment RouteAgencyInfo_route on Route {\n  agency {\n    name\n    url\n    fareUrl\n    id\n  }\n}\n\nfragment RoutePatternSelectContainerFragment_route_19b1FI on Route {\n  shortName\n  mode\n  type\n  color\n  gtfsId\n  patterns {\n    code\n    directionId\n    headsign\n    stops {\n      name\n      id\n    }\n    activeDates: trips {\n      serviceId\n      day: activeDates\n      id\n    }\n    tripsForDate(serviceDate: $date) {\n      stoptimes: stoptimesForDate(serviceDate: $date) {\n        scheduledDeparture\n        serviceDay\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment RouteStopListContainerFragment_pattern_4qWgxv on Pattern {\n  directionId\n  route {\n    mode\n    color\n    shortName\n    type\n    gtfsId\n    id\n  }\n  stops {\n    alerts {\n      alertEffect\n      alertSeverityLevel\n      effectiveEndDate\n      effectiveStartDate\n      id\n    }\n    firstDeparture: stoptimesWithoutPatterns(startTime: $startOfDay, timeRange: 7776000, numberOfDepartures: 1, omitCanceled: true) @include(if: $showStopStatusMarkers) {\n      serviceDay\n      realtimeDeparture\n    }\n    stopTimesForPattern(id: $patternId, startTime: $currentTime) {\n      realtime\n      realtimeState\n      realtimeArrival\n      realtimeDeparture\n      serviceDay\n      scheduledDeparture\n      pickupType\n      stop {\n        platformCode\n        id\n      }\n    }\n    gtfsId\n    lat\n    lon\n    name\n    desc\n    code\n    platformCode\n    zoneId\n    id\n  }\n  id\n}\n"
  }
};
})();

node.hash = "df76c8c9833367c98629c2ee75219f27";

export default node;
